import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-bootstrap';

import SpinnerButton from '../../../common/components/Button';
import ValidationAlert from '../../../app/components/ValidationAlert';
import FormRow from '../../../app/components/FormRow';
import { CreateUpdateJobPositionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import HarmfulFactorMultiSelector from '../HarmfulFactor/HarmfulFactorMultiSelector';

interface JobPositionEditorProps {
  id?: string;
  jobPosition: CreateUpdateJobPositionDto;
  handleClose?: () => void;
  show?: boolean;
  onCompleted: (
    jobPosition: CreateUpdateJobPositionDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
}

export const JobPositionEditor: React.FC<JobPositionEditorProps> = props => {
  const [jobPosition, setJobPosition] = useState(props.jobPosition);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (props.show) {
      setSaveErrors([]);
      setShowSaveErrors(false);
      setJobPosition(props.jobPosition);
    }
  }, [props.show, props.jobPosition, props.id]);

  const saveJobPosition = async () => {
    setIsSaving(true);
    props
      .onCompleted(jobPosition, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          setSaveErrors(saveStatus.errors);
          setShowSaveErrors(true);
        }
      })
      .catch(error => {
        setSaveErrors(error);
        setShowSaveErrors(true);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const propertyChange = (obj: Partial<CreateUpdateJobPositionDto>) => {
    setJobPosition({ ...jobPosition, ...obj });
  };

  return (
    <Modal
      onHide={props.handleClose}
      show={props.show}
      centered={true}
      keyboard={true}
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.id
            ? 'Edycja stanowiska predefiniowanego'
            : 'Dodawanie stanowiska predefiniowanego'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-2">
          <Card.Header>Stanowisko predefiniowane</Card.Header>
          <Card.Body>
            <Form className="d-grid gap-3">
              <FormRow controlId="name" label="Nazwa">
                <Form.Control
                  type="text"
                  value={jobPosition?.name || ''}
                  onChange={e => propertyChange({ name: e.target.value })}
                />
              </FormRow>
              {/* <FormRow controlId="harmfulFactorsIds" label="Czynniki szkodliwe"> */}
              <HarmfulFactorMultiSelector
                selectedHarmfulFactor={
                  jobPosition?.harmfulFactorsIds || undefined
                }
                onChange={options => {
                  const harmfulFactorsIds = (options || [])?.map(o => o?.value);
                  propertyChange({ harmfulFactorsIds });
                }}
              />
              {/* </FormRow> */}
            </Form>
          </Card.Body>
        </Card>
        <ValidationAlert
          show={showSaveErrors}
          errors={saveErrors}
          className="mt-3"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={props.handleClose}>
          Zamknij
        </Button>
        <SpinnerButton
          variant="outline-primary"
          isLoading={isSaving}
          onClick={saveJobPosition}
        >
          Zapisz
        </SpinnerButton>
      </Modal.Footer>
    </Modal>
  );
};
